import { Page } from '@betty/navigation';
import Categories from '../components/Categories/Categories';

function GamesPage() {
  return (
    <Page titleNS="games">
      <Categories />
    </Page>
  );
}

export default GamesPage;
